import { useEffect, useState } from 'react'
import {
  IconButton,
  TableCell,
  TableRow,
  useTheme,
  Box,
  useMediaQuery,
  Button,
  Link,
} from '@mui/material'

import { EConsumerChallengeStatus, IChallengeWithStats } from 'src/types'
import { useMe } from 'src/hooks'
import { ChevronDownIcon } from 'src/assets/icons/v2/ChevronDownIcon'
import { ChevronUpIcon } from 'src/assets/icons/v2/ChevronUpIcon'
import { TextTag } from 'src/components/text-tag'
import { getColorOrNameByChallengeStatus } from 'src/common/utils/get-color-or name-by-scan-status'
import { BodyRowCollapse } from './collapsed'

import { UtcAndLocalDatesCell } from 'src/components/utc-and-local-dates-cell'
import { getRaPathWithChallangeFilter, truncateString } from 'src/common/utils'
import { useNavigate } from 'react-router-dom'

interface IProps {
  item: IChallengeWithStats
  isOpen: boolean
}

export const TableBodyRow = ({ item, isOpen = false }: IProps) => {
  const [toggle, setToggle] = useState(isOpen)
  const navigate = useNavigate()
  const { data: curUser } = useMe()

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('tablet'))

  useEffect(() => {
    setToggle(isOpen)
  }, [isOpen])

  const handleCollapse = () => {
    setToggle((toggle) => !toggle)
  }

  return (
    <>
      <TableRow>
        <TableCell sx={{ borderBottom: 'unset', padding: '4px 0px 4px 4px' }}>
          <IconButton onClick={handleCollapse}>
            {toggle ? (
              <ChevronUpIcon size={28} color={theme.palette.custom.darkBlue2} />
            ) : (
              <ChevronDownIcon size={28} color={theme.palette.custom.darkBlue2} />
            )}
          </IconButton>
        </TableCell>
        <TableCell sx={{ borderBottom: 'unset', padding: 0 }}>
          {isMobile ? truncateString(item?.name, 16) : item?.name}
        </TableCell>
        <TableCell align="center" sx={{ borderBottom: 'unset', padding: 0 }}>
          <Link href={getRaPathWithChallangeFilter(item.name)}>
            {item?.userPlacement?.points || 0}
          </Link>
        </TableCell>
        <TableCell align="center" sx={{ borderBottom: 'unset', padding: 0 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flex: 1,
            }}
          >
            <Button
              sx={{ textTransform: 'none', p: '4px' }}
              onClick={() => navigate(getRaPathWithChallangeFilter(item.name))}
            >
              <TextTag
                label={getColorOrNameByChallengeStatus('text', item.status)}
                bgColor={
                  item.status === EConsumerChallengeStatus.PAID
                    ? theme.palette.common.white
                    : getColorOrNameByChallengeStatus('color', item.status)
                }
                color={
                  item.status === EConsumerChallengeStatus.PAID
                    ? theme.palette.custom.primary
                    : undefined
                }
                sx={{
                  minWidth: '65px',
                  borderColor:
                    item.status === EConsumerChallengeStatus.PAID
                      ? theme.palette.custom.primary
                      : undefined,
                }}
                variant={item.status === EConsumerChallengeStatus.PAID ? 'outlined' : 'filled'}
              />
            </Button>
          </Box>
        </TableCell>

        {!isMobile && (
          <TableCell align="center" sx={{ fontSize: '11px', borderBottom: 'unset', padding: 0 }}>
            <UtcAndLocalDatesCell date={item.start_date} loalTimezone={curUser?.timezone} />
          </TableCell>
        )}
        {!isMobile && (
          <TableCell align="center" sx={{ fontSize: '11px', borderBottom: 'unset', padding: 0 }}>
            <UtcAndLocalDatesCell date={item.end_date} loalTimezone={curUser?.timezone} />
          </TableCell>
        )}
      </TableRow>

      <BodyRowCollapse item={item} collapsed={toggle} userTz={curUser?.timezone} />
    </>
  )
}
